export default "__VITE_ASSET__BxOXLgM___"